import type {App, Plugin} from 'vue';
import 'primeicons/primeicons.css';
import { nl } from 'primelocale/nl.json';
import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';

import Athumi from '../styles/athumi-theme';
import '../styles/athumi-theme/design-tokens.css';
import '../styles/athumi-theme/athumi-theme.css';

import '../styles/tailwind-styles.css';

// customize locale
// better: clone + customize
nl.dateFormat = 'dd/mm/yy';

export default {
    install(app: App): void {

        app.use(PrimeVue, {
            ripple: true,
            theme: {
                preset: Athumi,
                options: {
                    darkModeSelector: false,
                    cssVariables: true,    // Ensures tokens map to CSS variables in the DOM
                },
            },
            locale: nl,

            // TODO: add to athumi theme
            // fixes PrimeVue behaviour (Datatable inside Panel will overflow the panel)
            pt: {
                panel: {
                    contentWrapper: {
                        style: {
                            minWidth: '0',
                        },
                    },
                },
            },
        });

        app.directive('tooltip', Tooltip);

    },
} as Plugin;
